module.exports = __webpack_public_path__ + "img/dba9286.png";